<script setup>

// Imports
import { defineLazyHydrationComponent } from '#imports'

import LogoGardenStatic from './static.vue'

const LazyLogoGardenCarousel = defineLazyHydrationComponent(
  'visible',
  () => import('./carousel.vue')
)

// Props
const props = defineProps({
  block: {
    type: Object,
    default: () => ({})
  }
})

</script>

<!-- -------------------------------------------------------------------------------------------------
    Template
------------------------------------------------------------------------------------------------- -->

<template>
<section class="logo-garden-carousel"
  :class="{ '--static': block?.isStatic }">
  <div class="container">

    <!-- Static: a plain logo grid, no slider -->
    <LogoGardenStatic
      v-if="block?.isStatic"
      :logoGardenImages="block?.['logoGardenContent']?.[0]?.images"
    />

    <LazyLogoGardenCarousel
      v-else
      :hydrate-on-visible="{ rootMargin: '300px' }"
      :logoGardenImages="block?.['logoGardenContent']?.[0]?.images"
      data-hydration="lazy-hydration"
    />

  </div>
</section>
</template>

<!-- -------------------------------------------------------------------------------------------------
    Styling
------------------------------------------------------------------------------------------------- -->

<style scoped>

.logo-garden-carousel {
  margin-bottom: 80px;

  @media (min-width: 1024px) {
    margin-bottom: 120px;
  }
}

.container {
  overflow: hidden;
}

/* The carousel runs edge to edge on mobile; the static grid keeps the container padding */
@media (max-width: 767px) {
  .logo-garden-carousel:not(.--static) .container {
    padding-inline: 0;
  }
}

</style>